import { AppBar, Toolbar, Typography, Box } from "@mui/material";

export default function PageHeader({ title, leftAction, rightAction }) {
  return (
    <AppBar
      position="static"
      elevation={1}
      sx={(theme) => ({
        bgcolor: "background.paper",
        color: "#5C4D3C",
        // PC端突破父容器限宽，占满整个视口
        [theme.breakpoints.up("md")]: {
          position: "relative",
          left: "50%",
          transform: "translateX(-50%)",
          width: "100vw",
        },
      })}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          minHeight: 48,
          px: 1,
        }}
      >
        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
          {leftAction}
        </Box>
        <Typography
          variant="h6"
          component="h1"
          fontWeight="bold"
          noWrap
          sx={{ flex: 1, textAlign: "center", color: "primary.main" }}
        >
          {title}
        </Typography>
        <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          {rightAction}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
